import React from "react";
import { Chip } from "@mui/material";

const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case 'confirmed': return { color: 'success', label: 'Confirmed' };
    case 'cancelled': return { color: 'error', label: 'Cancelled' };
    case 'pending': return { color: 'warning', label: 'Pending' };
    case 'unanswered': return { color: 'default', label: 'Unanswered' };
    case 'sent': return { color: 'info', label: 'Sent' };
    case 'draft': return { color: 'default', label: 'Draft' };
    default: return { color: 'default', label: status };
  }
};

const StatusChip = ({ status, ...props }) => {
  const { color, label } = getStatusColor(status);
  
  return (
    <Chip 
      label={label} 
      color={color} 
      variant="outlined" 
      size="small" 
      sx={{ 
         fontWeight: 'bold', 
         minWidth: 80,
         textTransform: 'capitalize'
      }} 
      {...props}
    />
  );
};

export default StatusChip;
